import PropTypes from 'prop-types'
import React from 'react'
import Modal from '../Modal'
import { Helmet } from 'react-helmet-async'
import get from 'lodash/get'
import { Icon } from 'Blocks'
import { ProductModalContent } from './components'
import config from 'Config'

const ProductModal = props => {
  const handleClick = e => {
    e.stopPropagation()
  }

  const variant = get(props, 'variant', null)
  const { productUuid = '', ccUuid = '' } = props
  return props.on ? (
    <Modal>
      <div className={props.className} onClick={props.close}>
        <div onClick={handleClick} className="product-modal__wrapper">
          <Helmet bodyAttributes={{ class: 'no-scroll' }} />
          <div className="product-modal__header">
            <h3 className="product-modal__header__title">
              {config.productModal.title}
            </h3>
            <Icon onClick={props.close} className="close-icon" name="close" />
          </div>
          <div className="product-modal__content">
            <ProductModalContent
              variant={variant}
              productUuid={productUuid}
              ccUuid={ccUuid}
            />
          </div>
        </div>
      </div>
    </Modal>
  ) : null
}

ProductModal.propTypes = {
  ccUuid: PropTypes.string,
  className: PropTypes.any,
  close: PropTypes.any,
  on: PropTypes.any,
  productUuid: PropTypes.string
}

export default ProductModal
